import { Outlet } from "@tanstack/react-router";

export function DetailsLayout() {
  return (
    <div className="min-h-screen bg-bg-primary">
      <main className="mx-auto max-w-2xl px-6 py-20">
        <Outlet />
      </main>
    </div>
  );
}
